import React from "react";
import { useTranslation } from "react-i18next";
import { SubPage, FullDivider } from "./SubPage";
import { ProductAnchor } from "../components/ProductAnchor";

const CASE_META: { slug: string; logo?: string; image?: string; tech: string[] }[] = [
  { slug: "cate", logo: "/assets/cate-logo.svg", image: "/assets/screenshots/cate.png", tech: ["Electron", "React", "Monaco", "xterm.js", "Zustand"] },
  { slug: "one-click-deploy", tech: ["CLI", "Bun", "React", "Docker", "Traefik"] },
  { slug: "sight", tech: ["Bun", "React", "PostgreSQL", "Redis"] },
  { slug: "skyline", tech: ["iOS"] },
  { slug: "foody", tech: ["iOS", "Hono", "PostgreSQL"] },
];

export function Work() {
  const { t } = useTranslation("work");
  const cases = t("cases", { returnObjects: true }) as { title: string; description: string }[];

  return (
    <SubPage title={t("title")} subtitle={t("subtitle")}>
      <div className="grid grid-cols-1 gap-px bg-grey-800">
        {CASE_META.map((c, i) => {
          const content = cases[i];
          if (!content) return null;
          return (
            <ProductAnchor key={c.slug} slug={c.slug} className="bg-grey-975 block group">
              {c.image && (
                <>
                  <div
                    className="w-full h-64 sm:h-80 md:h-96"
                    style={{
                      backgroundColor: "rgba(255,255,255,0.03)",
                      backgroundImage: `url(${c.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "top center",
                    }}
                  />
                  <div className="h-px bg-grey-800" />
                </>
              )}

              <div className="px-5 sm:px-8 md:px-[66px] py-8 md:py-10 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6">
                <div className="max-w-lg">
                  {c.logo ? (
                    <img src={c.logo} alt={content.title} className="h-5 w-auto object-contain mb-4" />
                  ) : (
                    <h3 className="text-base font-semibold text-white mb-3">{content.title}</h3>
                  )}
                  <p className="text-sm text-white/50 leading-relaxed">{content.description}</p>
                </div>
                <div className="flex flex-col items-end gap-3 shrink-0">
                  <div className="flex flex-wrap items-center gap-2">
                    {c.tech.map((tt) => (
                      <span key={tt} className="text-[9px] text-white/20 font-mono px-1.5 py-0.5 bg-white/[0.03]">{tt}</span>
                    ))}
                  </div>
                </div>
              </div>
            </ProductAnchor>
          );
        })}
      </div>
      <FullDivider />
    </SubPage>
  );
}
